import { React, useState, useEffect, useRef } from "react";
import "./NavigationBar.css";
import HomeIcon from '@mui/icons-material/Home';
import SettingsIcon from '@mui/icons-material/Settings';
import PersonIcon from '@mui/icons-material/Person';
import InfoIcon from '@mui/icons-material/Info';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import Settings from '../Settings/Settings';
import AboutMe from '../AboutMe/AboutMe';

function NavigationBar({ username }) {
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const [showSettings, setShowSettings] = useState(false);
	const [showAboutMe, setShowAboutMe] = useState(false);
	const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
	const navigate = useNavigate();
	const dropdownRef = useRef(null);
	const profileRef = useRef(null);

	const handleAvatarClick = () => {
		if (profileRef.current) {
			const rect = profileRef.current.getBoundingClientRect();
			setDropdownPosition({
				top: rect.bottom + 10,
				left: rect.left
			});
		}
		setIsDropdownOpen(!isDropdownOpen);
	};

	const handleLogout = () => {
		// Удаляем все ключи с префиксом lg_, которые сохраняет LoginScreen
		localStorage.removeItem('lg_userRole');
		localStorage.removeItem('lg_username');
		localStorage.removeItem('lg_userName');
		localStorage.removeItem('lg_userEmail');
		localStorage.removeItem('lg_userDepartment');
		localStorage.removeItem('lg_userPermissions');
		localStorage.removeItem('lg_savedUsername');
		localStorage.removeItem('lg_lastLogin');
		window.location.href = '/';
	};

	const handleBackClick = () => {
		navigate('/app');
	};

	const handleChangeUser = () => {
		console.log('Change user clicked');
		setIsDropdownOpen(false);
		// Здесь можно добавить логику смены пользователя
	};

	const handleAboutMe = () => {
		console.log('About me clicked');
		setIsDropdownOpen(false);
		setShowAboutMe(true);
	};

	const handleSettingsClick = () => {
		console.log('Settings clicked');
		setIsDropdownOpen(false);
		setShowSettings(true);
	};

	// Закрытие dropdown при клике вне его
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target) &&
				profileRef.current && !profileRef.current.contains(event.target)) {
				setIsDropdownOpen(false);
			}
		};

		if (isDropdownOpen) {
			document.addEventListener('mousedown', handleClickOutside);
		}

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [isDropdownOpen]);

	// Получаем первую букву имени для аватара
	const getInitial = () => {
		return username ? username.charAt(0).toUpperCase() : 'U';
	};

	return (
		<>
			<div className="top-nav">
				<div className="user-profile-container">
					<div
						ref={profileRef}
						className={`user-profile ${isDropdownOpen ? 'active' : ''}`}
						onClick={handleAvatarClick}
					>
						<div className="user-icon">
							{getInitial()}
						</div>
						<span>{username}</span>
					</div>
				</div>

				{isDropdownOpen && (
					<div
						ref={dropdownRef}
						className="dropdown-menu"
						style={{
							top: `${dropdownPosition.top}px`,
							left: `${dropdownPosition.left}px`,
							transform: `translateX(-${dropdownRef.current ?
								Math.max(0, dropdownRef.current.offsetWidth + dropdownPosition.left - window.innerWidth + 20)
								: 0}px)`
						}}
					>
						<ul>
							<li>
								<a href="#" onClick={(e) => { e.preventDefault(); handleChangeUser(); }}>
									<PersonIcon style={{ fontSize: 20, marginRight: '8px' }} />
									Change User
								</a>
							</li>
							<li>
								<a href="#" onClick={(e) => { e.preventDefault(); handleAboutMe(); }}>
									<InfoIcon style={{ fontSize: 20, marginRight: '8px' }} />
									About Me
								</a>
							</li>
							<li>
								<a href="#" onClick={(e) => { e.preventDefault(); handleSettingsClick(); }}>
									<SettingsIcon style={{ fontSize: 20, marginRight: '8px' }} />
									Settings
								</a>
							</li>
							<li>
								<button onClick={handleLogout}>
									<LogoutIcon style={{ fontSize: 20, marginRight: '8px' }} />
									Logout
								</button>
							</li>
						</ul>
					</div>
				)}

				<button className="home-button" onClick={handleBackClick}>
					<HomeIcon className="home-icon" />
				</button>

				<img className="logo" src="newLogo.png" alt="Company Logo" />
			</div>

			{showSettings && (
				<Settings onClose={() => setShowSettings(false)} />
			)}

			{showAboutMe && (
				<AboutMe username={username} onClose={() => setShowAboutMe(false)} />
			)}
		</>
	);
}

export default NavigationBar;